import { useRouteLoaderData } from "@remix-run/react";
import { RootLoaderReturn } from "~/types";

export function useRootLoaderData() {
  const data = useRouteLoaderData<RootLoaderReturn>("root");
  return data;
}
